import { Component, OnInit, HostListener } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { RescanJobInputDocument } from 'src/app/models/job';
import { ToastrService } from 'ngx-toastr';
import { OcrJob, OcrChannel, HttpStatus } from 'src/app/constants/constants';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigurationPage } from '../ConfigurationPage';

@Component({
  selector: 'app-rescan-job',
  standalone: false,
  templateUrl: './rescan-job.component.html',
  styleUrls: ['./rescan-job.component.scss']
})
export class RescanJobComponent implements OnInit, ConfigurationPage {

  currentInputDocument: RescanJobInputDocument | undefined;
  isloading = false;

  // form data
  documentNumValue = new FormControl('');
  selectedSupplier = new FormControl('');
  reason = new FormControl('');
  comment = new FormControl('');
  pdfWidth: number | null = null;

  constructor(private apiHandler: ApiService, private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  getNextFile(): void {
    this.isloading = true;
    const request = this.apiHandler.getABCisRequest<RescanJobInputDocument>(ABCisApi.Ocr, `job/${OcrJob.REQUEST_RESCAN}/next-document?channelId=${OcrChannel.WEB_UI}`);
    request.then(httpResponse => {
      if (httpResponse.status == HttpStatus.NO_CONTENT) {
        this.currentInputDocument = undefined;
        this.toastr.info('No more files available for Rescan job');
      } else {
        this.currentInputDocument = httpResponse.body;
      }
      this.isloading = false;
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  /**
   * This gets called when routing away from page
   */
  ReleaseDocument(): void {
    this.releaseFile();
  }

  releaseFile(): void {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument!.uuid}/release`);
    request.then((val) => {
      this.currentInputDocument = undefined;
      this.isloading = false;
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  changePdfWidth(num: number): void {
    this.pdfWidth = num;
  }

  @HostListener('window:beforeunload', ['$event'])
  OnClose($event: BeforeUnloadEvent): void {
    if(this.currentInputDocument !== undefined) $event.returnValue = 'Are you sure you want to leave?';
  }

  onRequestRescanClick(): void {
    this.isloading = true;

    const data: RescanRequestDetails = {
      documentNumber : this.documentNumValue.value || '',
      supplier : this.selectedSupplier.value || '',
      reason : this.reason.value || '',
      comment : this.comment.value || ''
    };

    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument!.uuid}/send-rescan-email`, data);
    request.then((val) => {
      this.resetForm();
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  resetForm(): void {
    this.documentNumValue.setValue('');
    this.selectedSupplier.setValue('');
    this.reason.setValue('');
    this.comment.setValue('');
  }

  onRestoreClick(): void {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument!.uuid}/redo-category-in-web`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  onAllocateClick(): void {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument!.uuid}/to-allocator`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }
}

interface RescanRequestDetails {
  documentNumber: string;
  supplier: string;
  reason: string;
  comment: string;
}
